export const GOOGLE_ADS_TARGETING_KEY_NEW_CAR_PROMOTION = 'TacticalAdsPromoID';
export const GOOGLE_ADS_TARGETING_KEY_NEW_CAR_COMPETITOR = 'TacticalAdsCompID';

export const PROMO_TYPE_TACTICAL = 'tactical_ads';
export const PROMO_TYPE_NORMAL = 'normal_promo';

export const PROMOTION_POSTED_ON_DATE_FORMAT = 'DD-MMM-YYYY';
